module.exports = __webpack_public_path__ + "8e690a5aa1fbe3a4fb3797cd327b926e.svg";